import { render } from "./WithdrawalPage.vue?vue&type=template&id=d2cbe97a&scoped=true"
import script from "./WithdrawalPage.vue?vue&type=script&lang=js"
export * from "./WithdrawalPage.vue?vue&type=script&lang=js"

import "./WithdrawalPage.vue?vue&type=style&index=0&id=d2cbe97a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2cbe97a"]])

export default __exports__